import {createRouter, createWebHistory} from 'vue-router'
import Home from '@/views/Home.vue'
import Results from '@/views/Results.vue'
import Contact from '@/views/Contact.vue'
import CurrentEdition from '@/views/CurrentEdition.vue'

const routes = [
    {path: '/', name: 'Home', component: Home},
    {path: '/results', name: 'Results', component: Results},
    {path: '/2024Edition', name: '2024Edition', component: CurrentEdition},
    {path: '/contact', name: 'Contact', component: Contact}
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router